import { createAction, props } from '@ngrx/store';

import {
  LastMailingReportsPageState,
  MailingReportItem,
  MailingReportsList,
} from '@store/mailingReports/mailingReports.state';

export const loadMailingReportsList = createAction(
  '[stateMailingReport] Load Mailing Reports List',
);

export const loadMailingReportsListSuccess = createAction(
  '[stateMailingReport] Load Mailing Reports List Success',
  props<{
    list: MailingReportsList;
  }>(),
);

export const loadMailingReportsListFailure = createAction(
  '[stateMailingReport] Load Mailing Reports List Failure',
  props<{
    error: string;
  }>(),
);

export const addMailingReportItem = createAction(
  '[stateMailingReport] Add Mailing Report Item',
  props<{
    item: MailingReportItem;
  }>(),
);
export const updateMailingReportItem = createAction(
  '[stateMailingReport] Update Mailing Report Item',
  props<{
    id: number;
    changes: Partial<MailingReportItem>;
  }>(),
);
export const deleteMailingReportItem = createAction(
  '[stateMailingReport] Delete Mailing Report Item',
  props<{
    id: number;
  }>(),
);

export const setLastPageStateMailingReports = createAction(
  '[stateMailingReport] Set last page state',
  props<{
    newPageState: Partial<LastMailingReportsPageState>;
  }>(),
);
